import calculateWinner from './calculateWinner'
const infinity = Math.pow(10, 1000);
function bestMove(board){
  var bestScore=-infinity;
  var move=4;
  for(let i=0;i<9;i++)
  {
    if(board[i]==null)
    {
      board[i]='O';
      let score=minimax(board,0,false);
      board[i]='';
      console.log("ENTER "+i);
      if(score>bestScore)
      {
        console.log("THIS IS i "+i);
        bestScore=score;
        move=i;
      }
    }
  }
  return move;
}
function minimax(board,depth,isMaximizing){
let winner=calculateWinner(board);
if(winner)
{
let score;
if(winner=='X')
{score=1;}
else if(winner=='O')
{score=-1;}
return score;
}
else{
if(isMaximizing)
{
  let bestScore=-infinity;
  for(let i=0;i<9;i++)
  {
      if(board[i]==null)
      {
        console.log("This is isMaximizing "+i);
        board[i]='O';
        let score=minimax(board,depth+1,false);
        board[i]='';
        bestScore=Math.max(score,bestScore);
      }
  }
  //console.log(bestScore);
  return bestScore;
}
else
{
  let bestScore=infinity;
  for(let i=0;i<9;i++)
  {
      if(board[i]==null)
      {
        console.log("this is not isMaximizing "+i);
        board[i]='X';
        let score=minimax(board,depth+1,true);
        board[i]='';
        bestScore=Math.min(score,bestScore);
      }
    }
    console.log(bestScore);
  return bestScore;
}
}

}
export default bestMove
